<template>
  <div>
    <b-card
    no-body
    border-variant="msstream"
    class="marginal"
    >
      <b-card-header
        header-bg-variant="msstream"
        header-text-variant="white"
        class="text-center"
      >
        <h6 class="m-0">
          <b-row class="align-items-center justify-content-center">
            <b-icon icon="file-earmark-code-fill" />&nbsp;LOGS
          </b-row>
        </h6>
      </b-card-header>
      <b-card-body class="small">
        <b-form @submit.prevent="getLogs">
          <b-row class="justify-content-around align-items-center">
            <b-col cols="auto">
              <b-form-group label-for="inputuser" :label="$ml.get('logsUser')">
                <b-form-input size="sm" id="inputuser" type="text" v-model="user" :placeholder="$ml.get('logsUser')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="auto">
              <b-form-group label-for="inputmethod" :label="$ml.get('logsMethod')">
                <b-form-select size="sm" id="inputmethod" v-model="method" :options="optionsMethod"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="auto">
              <b-form-group label-for="inputendpoint" :label="$ml.get('logsEndpointUrl')">
                <b-input size="sm" id="inputendpoint" type="text" v-model="url" :placeholder="$ml.get('logsEndpointUrl')"></b-input>
              </b-form-group>
            </b-col>
            <b-col cols="auto">
              <b-form-group label-for="inputpagesize" :label="$ml.get('logsSize')">
                <b-form-select size="sm" id="inputpagesize" v-model="pagesize" :options="optionsPagesize"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="auto">
              <b-button size="sm" variant="mswarning" type="submit"><b-icon icon="arrow-repeat" /> {{$ml.get('update')}}</b-button>
            </b-col>
          </b-row>
        </b-form>
        <b-table
          show-empty
          centered
          responsive
          striped
          bordered
          :items="logs"
          :fields="logFields"
          class="marginaltop"
        >
          <template v-slot:cell(endpoint)="row">
            {{row.item.method}} {{row.item.url}}
          </template>
        </b-table>

        <b-pagination 
          size="sm"
          v-if="logs.length !== undefined && logs.length > 0" 
          align="center" 
          :limit="8" 
          :total-rows="realTotalNumberOfPage" 
          v-model="page" 
          :per-page="1" 
          first-number last-number 
          @input="getLogs()">
        </b-pagination>

      </b-card-body>
    </b-card>
  </div>
</template>

<script>

import LoginService from '@/services/login.service.js';

let loginService = new LoginService();

export default {
  name: "Logs",

  data() {
    return {
        clientView: this.$auth.isAdmin()
          ? this.$auth.getMyClientView() || this.$auth.getMyUser().client
          : this.$auth.getMyUser().client,
        logs: [],
        optionsPagesize: [
          {value: 5, text: "5"},
          {value: 10, text: "10"},
          {value: 20, text: "20"},
          {value: 50, text: "50"},
        ],
        user: "",
        method: "all",
        url: "",
        page: 1,
        pagesize: 5,
        realTotalNumberOfPage: 1,
        errorGettingLogs: false,
        loadingLogs: false
    }
  },
  computed: {
    logFields() {
      return [
        { key: "timestamp", label: this.$ml.get('logsDate'),  thClass: 'text-center', tdClass: 'align-middle' },
        { key: "user", label: this.$ml.get('logsUser'),  thClass: 'text-center', tdClass: 'align-middle' },
        { key: "endpoint", label: this.$ml.get('logsEndpoint'),  thClass: 'text-center', tdClass: 'align-middle' },
        { key: "request", label: this.$ml.get('logsRequestLog'),  thClass: 'text-center', tdClass: 'align-middle' },
        { key: "response", label: this.$ml.get('logsResponseLog'),  thClass: 'text-center', tdClass: 'align-middle' },
      ];
    },
    optionsMethod() {
      return [
        {value: "all", text: this.$ml.get('logsAll')},
        {value: "POST", text: "POST"},
        {value: "PUT", text: "PUT"},
        {value: "DELETE", text: "DELETE"},
      ];
    },
  },
  mounted() {
    this.getLogs()
  },
  methods: {
    getLogs() {
        this.errorGettingLogs = false;
        this.loadingLogs = true;
        let data = {page: this.page, pagesize: this.pagesize, client: this.clientView}
        if (this.user) {
          data.user = this.user;
        }
        if (this.url) {
          data.url = this.url;
        }
        if (this.method && this.method !== "all") {
          data.method = this.method;
        }
        loginService.getLogs(data, this.$auth.token())
        .then(logs => {
            this.logs = logs._embedded;
            this.loadingLogs = false;
            this.realTotalNumberOfPage = logs._total_pages;
        }).catch(err => {
            this.errorGettingLogs = true;
            this.loadingLogs = false;
        })
    }
    
  }
}
</script>

<style scoped>

</style>
